<template>
    <div class="camera-client">
        <title-screen title="17"></title-screen>
        <div class="panel anken-info-panel">
            <AnkenInfo :id="ankenId" ref="ankenInfo" @ankenInfoLoad="ankenInfoLoad"/>
        </div>
        <div v-if="isLoading || isLoadingDocumentData" class="panel loading-panel" style="text-align: center; padding-top: 50px;">
            <img src="@/assets/images/loading.gif" alt="loading">
        </div>
        <div v-else>
            <div id="document-list">
                <DocumentList :documentData="documentData" :id="ankenId" @scrollSubject="scrollSubject"/>
            </div>
            <div class="panel list-document-panel" v-for="(item, index) in tableData" :key="index" id="data_view">
                <CameraRow :data="item" :is-finished-anken="isFinishedAnken"/>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash'
import CameraClientApi from '@/api/camera/camera-client.js'
import AnkenInfo from '../38_anken/AnkenInfo.vue'
import CameraRow from './CameraRow.vue'
import TitleScreen from '@/components/common/TitleScreen'
import { isIE } from '@/common/useragent'
import DocumentList from '@/views/pages/client/7_document/DocumentList'
import DocumentApi from '@/api/document/document.js'

export default {
    name: 'camera-client',
    data () {
        return {
            tableData: [],
            ankenId: 0,
            isLoading: false,
            isFinishedAnken: false,
            isAnkenInfoLoaded: false,
            isPagesLoaded: false,
            documentData: {},
            isLoadingDocumentData: true
        }
    },
    components: {
        DocumentList,
        TitleScreen,
        AnkenInfo,
        CameraRow
    },
    created () {
        this.ankenId = parseInt(this.$route.params.id)
        this.loadData(true)
        this.loadDocument()
        this.$bus.$on('refreshCamera', () => {
            this.loadData(false)
        })
        this.$bus.$on('moveMenuSubject', (id) => {
            this.scrollSubject(id)
        })
        this.$bus.$on('reLoadDocument', async () => {
            await this.loadDocument()
        })
        this.$bus.$on('reloadAnken', async () => {
          if (this.$refs.ankenInfo) {
            await this.$refs.ankenInfo.loadAnken()
          }
        })
        this.checkFinishedAnken()
    },
    methods: {
        loadData (refresh) {
            this.isLoading = refresh
            const data = {
                'ankenId': this.ankenId
            }
            CameraClientApi.getDocumentList(data).then(response => {
                if (response.status === 200) {
                    const dataOutput = response.data
                    const result = _.chain(dataOutput)
                        .groupBy('categoryId')
                        .map(function (v, i) {
                            return {
                                categoryId: i,
                                categoryName: _.get(_.find(v, 'categoryName'), 'categoryName'),
                                subjects: v,
                                isPublish: _.filter(v, function (obj) {
                                    return obj.disclosureFlag === true
                                }).length > 0
                            }
                        })
                        .value()

                    const prefix = 'Thumbnail_'
                    result.forEach((value) => {
                        value.subjects.forEach((subjectsValue) => {
                            subjectsValue.files.forEach((filesValue) => {
                                let fileName = filesValue.filePath.split('/').reverse()[0]
                                let thumbnailFilePath = filesValue.filePath.replace(fileName, prefix + fileName)
                                const payload = {
                                    filePath: thumbnailFilePath
                                }
                                DocumentApi.getSignedUrl(payload).then(response => {
                                    if (response.status === 200) {
                                        this.$set(filesValue, 'thumbnailImageSignedUrl', response.data.signedUrl)
                                    }
                                })
                                .catch(err => {
                                    throw err
                                })
                            })
                        })
                    })
                    this.tableData = result
                    this.isLoading = false
                    this.isPagesLoaded = true
                }
            })
            .catch(err => {
                throw err
            })
        },
        scrollSubject (id) {
            let subjectView = document.getElementById(id)
            if (subjectView) {
                let scrollTop = subjectView.getBoundingClientRect().y + window.scrollY
                var navHeight = 0
                if (scrollTop >= 170 && window.innerWidth > 600 && window.innerHeight > 400) {
                    const navViews = document.getElementsByClassName('gnav nav-height')
                    if (navViews.length > 0) {
                        const navView = navViews[0]
                        if (navView) {
                            navHeight = navView.offsetHeight
                            scrollTop -= navHeight
                            if (this._$(navView).css('position') !== 'fixed') { // check navView position from static to fixed
                              scrollTop -= navHeight
                            }
                        }
                    }
                }
                window.scroll(0, scrollTop)
            }
        },
        ankenInfoLoad (val) {
            this.isAnkenInfoLoaded = val
            if (val === true) {
                this.checkFinishedAnken()
            }
        },
        async loadDocument () {
            const ankenId = parseInt(this.$route.params.id)
            const res = await DocumentApi.getRequiredDocument({ ankenId: ankenId })
            if (res.data) {
                this.documentData = _.groupBy(res.data, 'categoryId')
            }
            this.isLoadingDocumentData = false
        },
        scrollToBottom () {
            if (this.isAnkenInfoLoaded && this.isPagesLoaded) {
                this.$nextTick(() => {
                    const ankenViews = document.getElementsByClassName('anken-info')
                    if (ankenViews.length > 0) {
                        const ankenView = ankenViews[0]
                        if (ankenView) {
                            var navHeight = 0
                            if (window.innerWidth > 600 && window.innerHeight > 400) {
                                const navViews = document.getElementsByClassName('gnav nav-height')
                                if (navViews.length > 0) {
                                    const navView = navViews[0]
                                    if (navView) {
                                        navHeight = navView.offsetHeight
                                        if (!isIE() && this._$(navView).css('position') === 'static') navHeight += 60
                                    }
                                }
                            }
                            const scrollTop = ankenView.offsetTop + ankenView.offsetHeight - navHeight
                            window.scroll(0, scrollTop)
                        }
                    }
                })
            }
        },
        checkFinishedAnken () {
            const ankenListStr = localStorage.getItem('ankenInfo')
            if (ankenListStr !== null) {
                const ankenInfo = JSON.parse(localStorage.getItem('ankenInfo'))
                this.isFinishedAnken = ankenInfo.status === '業務完了' || ankenInfo.status === '生産完了'
            }
        }
    },
    watch: {
        isAnkenInfoLoaded: function () {
            this.scrollToBottom()
        },
        isPagesLoaded: function () {
            this.scrollToBottom()
        }
    }
}
</script>

<style>
    @import './camera.css';
</style>
